// extracted by mini-css-extract-plugin
export default {"switchGroup":"Switch_switchGroup__SsIB3","input":"Switch_input__sYZ3c","label":"Switch_label__QAEtB","switch":"Switch_switch__BNSXe","slider":"Switch_slider__mLDAm"};